import { render, staticRenderFns } from "./import-agronomo.vue?vue&type=template&id=6b47de17&"
import script from "./import-agronomo.vue?vue&type=script&lang=js&"
export * from "./import-agronomo.vue?vue&type=script&lang=js&"
import style0 from "./import-agronomo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports